import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SearchBar from '../../SearchBar';
import CategoryItem from '../../dump/menuComponents/CategoryItem';
import './Reports.sass';
import StandardReportTable from './StandardReportTable';
import ReportSubscriptionsModal from './Modals/ReportSubscriptionsModal';
import NewReportModal from './Modals/NewReportModal';
import DownloadReportsModal from './Modals/DownloadReportsModal';
import _ from 'lodash';
import { standardReportData } from './ReportsHelpers';
import { isInternalUser } from '../../helpers/constants';
import CustomButton from '../../CustomButton';
import { FaDownload } from 'react-icons/fa';
import { getCustomDV7Access, getDV7Access } from '../../helpers/helperDV7Access';
// import { GEOFENCING_COMPANIES_IDS, GEOFENCING_PARTNERS_NAMES } from "../../../utils/constants";

const ReportsContainer = (props) => {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'reportsPage.reportsContainer' });
    const { t: standardReportTableT } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportTable' });
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const company = useSelector(state => state.company.company);
    // const supportExitEntryReport = GEOFENCING_COMPANIES_IDS.includes(company.company_id) || GEOFENCING_PARTNERS_NAMES.includes(company.partner);
    const zonesExitEntryReport = useSelector(state => state.reports.zonesExitEntryReport);
    const fleetReports = [], driverReports = [], cameraHealthReports = [], adminReports = [];
    const DV7access = getDV7Access(company);
    const customDV7Access = getCustomDV7Access(company);

    standardReportData(DV7access, customDV7Access).forEach(report => {
        if (report.id === '20' && !company.company_data?.geofencing_active) {
            return
        }

        switch (report.type) {
            case 'Fleet Activity':
                fleetReports.push(report)
                break;
            case 'Driver Activity':
                driverReports.push(report)
                break;
            case 'Camera Health':
                cameraHealthReports.push(report)
                break;
            case 'Admin Reports':
                adminReports.push(report)
                break;
        }
    })

    const [showSubscriptions, setShowSubscriptions] = useState(false);
    const [showNewReport, setShowNewReport] = useState(false);
    const [showDownloadReports, setShowDownloadReports] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [reportSearch, setReportSearch] = useState('');

    const { showReport } = props;
    const userRole = user.roles[0];
    const user_permissions = user.permissions || [];

    useEffect(() => {
        const { selectedReport } = props;
        if (selectedReport && selectedReport.name) {
            selectReport(selectedReport);
        }
    }, [])

    useEffect(() => {
        if (zonesExitEntryReport) {
            const { reportId } = zonesExitEntryReport;
            const report = standardReportData(DV7access, customDV7Access).find(standardReport => standardReport.id === reportId);
            if (report) {
                selectReport(report);
            }
        }
        return () => {
            dispatch({ type: 'RESET_ZONES_REPORT' });
        }
    }, [zonesExitEntryReport]);

    const selectReport = (selectedReport) => {
        setSelectedReport(selectedReport)
        props.handleShowReport();
    }

    const viewReport = (report) => {
        if (report.report_type === 'standard') {
            selectReport(standardReportData(DV7access, customDV7Access).find(standardReport => standardReport.id === report.report_id.toString()));
        }
        else {
            const formattedReport = {
                id: report.report_id,
                name: report.report_name,
                fields: report.report_fields,
                vehicles: report.report_vehicles,
                owner_id: report.report_owner === user.email ? user.id : null,
                user: report.report_users
            }
            setShowSubscriptions(false)
            props.handleNavigation(2, formattedReport)
        }
        setShowSubscriptions(false)
    }

    const goToCustomReports = () => {
        setShowNewReport(false)
        props.handleNavigation(2);
    }

    return (
        <div className="reports-container">
            {!showReport ?
                <>
                    <div className='page-subheader'>
                        <div className='subheader-section search-flex'>
                            <SearchBar term={reportSearch} onSearch={(e) => setReportSearch(e.target.value)} />
                            {(!['custom_user', 'custom_partner'].includes(userRole) || _.find(user_permissions, { 'perm_category_id': 3, 'a_edit': true })) &&
                                <CustomButton
                                    variant="primary"
                                    size="sm"
                                    onClick={() => setShowNewReport(true)}
                                >
                                    {t('btnAddReport')}
                                </CustomButton>
                            }
                        </div>
                        <div className='subheader-section reports-actions-section'>
                            <CustomButton
                                variant="primary-outline"
                                prefix="download-reports-button"
                                onClick={() => setShowDownloadReports(true)}
                            >
                                <FaDownload className="download-reports-icon" />
                                <span>{standardReportTableT('downloadReportsTitle')}</span>
                            </CustomButton>
                            <CustomButton
                                variant="primary-outline"
                                onClick={() => setShowSubscriptions(true)}
                            >
                                {t('btnAutomatedReports')}
                            </CustomButton>
                        </div>
                    </div>

                    <main className={'reports-body main-content-block' + (['custom_user', 'custom_partner'].includes(userRole) ? ' two-columns' : '')}>
                        <section className='reports-category'>
                            <h3 className='category-title'>{t('titleFleetActivity')}</h3>
                            <div className='category-subheader'>{t('subheaderFleetActivity')}</div>
                            <div className='category-list'>
                                {fleetReports.map(report => {
                                    const matchesSearch = !reportSearch || report.name.toLowerCase().includes(reportSearch.toLowerCase());
                                    // const isSpecialReport = !isProd || (isProd && report.id === '20' && supportExitEntryReport);
                                    // const isSpecialReport = report.id === '20' && supportExitEntryReport
                                    // const shouldRender = isSpecialReport || (report.id !== '20' && matchesSearch);
                                    // if (shouldRender) {
                                    if (matchesSearch) {
                                        return <CategoryItem
                                            key={report.id}
                                            onClick={() => selectReport(report)}
                                            text={i18n.t(`reportsPage.standardReportData.${report.name.replace(/\s/g, "_")}`)}
                                            withArrow
                                        />
                                    }
                                })}
                            </div>
                        </section>

                        {!['custom_user', 'custom_partner'].includes(userRole) &&
                            <section className='reports-category'>
                                <h3 className='category-title'>{t('titleDriverActivity')}</h3>
                                <div className='category-subheader'>{t('subheaderDriverActivity')}</div>
                                <div className='category-list'>
                                    {driverReports.map(report => {
                                        const matchesSearch = !reportSearch || report.name.toLowerCase().includes(reportSearch.toLowerCase());
                                        // const isSpecialReport = isProd && report.id === '20' && supportExitEntryReport;
                                        // const isSpecialReport = report.id === '20' && supportExitEntryReport
                                        // const shouldRender = isSpecialReport || (report.id !== '20' && matchesSearch);
                                        // if (shouldRender) {
                                        if (matchesSearch) {
                                            return <CategoryItem
                                                key={report.id}
                                                onClick={() => selectReport(report)}
                                                text={i18n.t(`reportsPage.standardReportData.${report.name.replace(/\s/g, "_")}`)}
                                                withArrow
                                            />
                                        }
                                    })}
                                </div>
                            </section>
                        }

                        <section className='reports-category'>
                            <h3 className='category-title'>{t('titleCameraHealth')}</h3>
                            <div className='category-subheader'>{t('subheaderCameraHealth')}</div>
                            <div className='category-list'>
                                {cameraHealthReports.map(report => {
                                    const matchesSearch = !reportSearch || report.name.toLowerCase().includes(reportSearch.toLowerCase());
                                    // const isSpecialReport = isProd && report.id === '20' && supportExitEntryReport;
                                    // const isSpecialReport = report.id === '20' && supportExitEntryReport
                                    // const shouldRender = isSpecialReport || (report.id !== '20' && matchesSearch);
                                    // if (shouldRender) {
                                    if (matchesSearch) {
                                        return <CategoryItem
                                            key={report.id}
                                            onClick={() => selectReport(report)}
                                            text={i18n.t(`reportsPage.standardReportData.${report.name.replace(/\s/g, "_")}`)}
                                            withArrow
                                        />
                                    }
                                })}
                            </div>
                        </section>

                        {isInternalUser(userRole) &&
                            <section className='reports-category'>
                                <h3 className='category-title'>{t('titleAdminReports')}</h3>
                                <div className='category-subheader'>{t('subheaderAdminReports')}</div>
                                <div className='category-list'>
                                    {adminReports.map(report => {
                                        const matchesSearch = !reportSearch || report.name.toLowerCase().includes(reportSearch.toLowerCase());
                                        // const isSpecialReport = isProd && report.id === '20' && supportExitEntryReport;
                                        // const isSpecialReport = report.id === '20' && supportExitEntryReport
                                        // const shouldRender = isSpecialReport || (report.id !== '20' && matchesSearch);
                                        // if (shouldRender) {
                                        if (matchesSearch) {
                                            return <CategoryItem
                                                key={report.id}
                                                onClick={() => selectReport(report)}
                                                text={i18n.t(`reportsPage.standardReportData.${report.name.replace(/\s/g, "_")}`)}
                                                withArrow
                                            />
                                        }
                                    })}
                                </div>
                            </section>
                        }
                    </main>
                </> :
                <StandardReportTable
                    goBack={() => props.handleNavigation(1)}
                    selectedReport={selectedReport}
                    mainTabs={props.mainTabs}
                    breadcrumbs={props.breadcrumbs}
                />
            }
            {showSubscriptions &&
                <ReportSubscriptionsModal
                    onHide={() => setShowSubscriptions(false)}
                    viewReport={viewReport}
                />}
            {showNewReport &&
                <NewReportModal
                    onHide={() => setShowNewReport(false)}
                    userReports={[]}
                    goToCustomReports={goToCustomReports}
                />}
            {showDownloadReports &&
                <DownloadReportsModal onHide={() => setShowDownloadReports(false)} />}
        </div>
    )
}

export default ReportsContainer;
